import {createStore, combineReducers, applyMiddleware} from "redux";
import schematicReducers from './Schematic_store/index'
import userReducers from "./User_store/index";
import thunk from 'redux-thunk';


const store = createStore(combineReducers({
    schematicReducers,
    userReducers
}), applyMiddleware(thunk));

export default store;
